export default __webpack_public_path__ + "static/media/green-city.4410640c.svg";